import { Button, Intent, TextArea } from '@blueprintjs/core'
import * as React from 'react'

export interface EditorProps {
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onSubmit: () => void
  editMode?: boolean
  onCancel?: () => void
  value: string
  placeholderText?: string
}

const Editor: React.FC<EditorProps> = ({
  editMode,
  value,
  onCancel,
  onChange,
  onSubmit,
  placeholderText = 'Leave a note'
}) => {
  return (
    <>
      <TextArea
        style={{ width: '100%', minHeight: 85, marginBottom: 10 }}
        onChange={onChange}
        value={value}
        placeholder={placeholderText}
      />
      {editMode && (
        <Button onClick={onCancel} intent={Intent.NONE} style={{ marginRight: 10 }}>
          Cancel
        </Button>
      )}
      <Button disabled={!value} onClick={onSubmit} intent={Intent.SUCCESS} style={{ marginLeft: 'auto' }}>
        {editMode ? 'Update note' : 'Add note'}
      </Button>
    </>
  )
}

export default Editor
